import {request} from "./request";
import {config} from "./config";

function uploadMediaImage(data, cb, fail_cb) {
    let url = config.apiList.uploadMediaImage + '?';
    if (data.scene) {
        url = url + "&scene=" + data.scene;
    }
    request.post.call(this, url, data, null, cb, fail_cb)
}

function createMediaActivity(data, cb, fail_cb) {
    let url = config.apiList.mediaActivity + '?';
    if (data.mpAuthConfigId) {
        url = url + "&mpAuthConfigId=" + data.mpAuthConfigId;
    }
    if (data.scene) {
        url = url + "&scene=" + data.scene;
    }
    request.post.call(this, url, data, null, cb, fail_cb)
}

function createMediaActivityText(data, cb, fail_cb) {
    let url = config.apiList.mediaActivityText + '?'

    if (data.mpAuthConfigId) {
        url = url + "&mpAuthConfigId=" + data.mpAuthConfigId;
    }
    if (data.scene) {
        url = url + "&scene=" + data.scene;
    }
    request.post.call(this, url, data, null, cb, fail_cb)
}

function reUseMediaImage(data, cb, fail_cb) {
    let url = config.apiList.reUseMediaImage + '?';
    request.get.call(this, url, data, cb, fail_cb)
}

function getMediaActivity(data, cb, fail_cb) {
    let url = config.apiList.mediaActivity + '?';
    request.get.call(this, url, data, cb, fail_cb)
}

function getMediaActivityTexts(data, cb, fail_cb) {
    let url = config.apiList.mediaActivityText + '?';
    request.get.call(this, url, data, cb, fail_cb)
}

function getMediaActivityImages(data, cb, fail_cb) {
    let url = config.apiList.mediaActivityImages + '?';
    request.get.call(this, url, data, cb, fail_cb)
}

function deleteMediaActivityImage(data, cb, fail_cb) {
    let url = config.apiList.mediaActivityImages + "/" + data.id + '?';
    request.deleteRequest.call(this, url, data, cb, fail_cb)
}

var mediaActivityApi = {
    uploadMediaImage: uploadMediaImage,
    getMediaActivity: getMediaActivity,
    reUseMediaImage: reUseMediaImage,
    createMediaActivity: createMediaActivity,
    createMediaActivityText: createMediaActivityText,
    getMediaActivityTexts: getMediaActivityTexts,
    getMediaActivityImages: getMediaActivityImages,
    deleteMediaActivityImage: deleteMediaActivityImage,
}

export {
    mediaActivityApi
}